import { useEffect } from 'react'

// Listens for push_event/3 events from the server.
// These get received on the frontend as `phx:event-name-here` events.
export function usePhxEventListener(event: string, handler: EventListenerOrEventListenerObject) {
  useEffect(() => {
    window.addEventListener(`phx:${event}`, handler)
    return () => window.removeEventListener(`phx:${event}`, handler)
  }, [event, handler])
}
